// extracted by mini-css-extract-plugin
export default {"wrap_modal":"FrameModals_wrap_modal__VxQh6","modal_content":"FrameModals_modal_content__xPqCT","header":"FrameModals_header__XFvmy","main":"FrameModals_main__2NvQZ"};